import { FormattedMessage } from "react-intl";
import LockedByOthersIcon from "../../../components/Common/SvgIcons/SocialIcons/LockedByOthersIcon";
import { moderateContributions } from "./moderateContributions";

export const lockedByOthers = {
  label: <FormattedMessage id="LockedByOthers_Txt" />,
  path: (tenantName) =>
    `${moderateContributions.path(tenantName)}/lockByOthers`,
  icon: (fill) => <LockedByOthersIcon fill={fill} />,
  searchPlaceHolder: "Search locked by others by name",
};
